var exports = {
  "E6": "ChannelEmbed.module__embed___Q1V6TX",
  "vO": "ChannelEmbed.module__embedFull___Q1V6TX",
  "UT": "ChannelEmbed.module__gridContainer___Q1V6TX",
  "Vg": "ChannelEmbed.module__grid___Q1V6TX",
  "$H": "ChannelEmbed.module__hasThumbnail___Q1V6TX",
  "zE": "ChannelEmbed.module__embedContent___Q1V6TX",
  "Cj": "ChannelEmbed.module__embedLink___Q1V6TX",
  "zC": "ChannelEmbed.module__embedProvider___Q1V6TX",
  "rN": "ChannelEmbed.module__embedAuthor___Q1V6TX",
  "QQ": "ChannelEmbed.module__embedAuthorName___Q1V6TX",
  "av": "ChannelEmbed.module__embedAuthorNameLink___Q1V6TX",
  "SG": "ChannelEmbed.module__embedAuthorIcon___Q1V6TX",
  "gt": "ChannelEmbed.module__embedTitle___Q1V6TX",
  "cD": "ChannelEmbed.module__embedDescription___Q1V6TX",
  "j0": "ChannelEmbed.module__embedFields___Q1V6TX",
  "Me": "ChannelEmbed.module__embedField___Q1V6TX",
  "$L": "ChannelEmbed.module__embedFieldName___Q1V6TX",
  "VN": "ChannelEmbed.module__embedFieldValue___Q1V6TX",
  "oy": "ChannelEmbed.module__embedFooterText___Q1V6TX",
  "W$": "ChannelEmbed.module__embedMedia___Q1V6TX",
  "ad": "ChannelEmbed.module__embedThumbnail___Q1V6TX",
  "te": "ChannelEmbed.module__embedFooter___Q1V6TX",
  "mG": "ChannelEmbed.module__embedFooterIcon___Q1V6TX",
  "i8": "ChannelEmbed.module__embedFooterSeparator___Q1V6TX",
  "PN": "ChannelEmbed.module__embedGifvContainer___Q1V6TX",
  "kL": "ChannelEmbed.module__container___Q1V6TX",
  "mQ": "ChannelEmbed.module__mediaFrame___Q1V6TX",
  "Mc": "ChannelEmbed.module__suppressButton___Q1V6TX",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___Q1V6TX",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___Q1V6TX",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___Q1V6TX",
  "$j": "ChannelEmbed.module__blueskyEngagement___Q1V6TX",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___Q1V6TX",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___Q1V6TX",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___Q1V6TX",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___Q1V6TX",
};

module.exports = exports;
